import React from "react";
import PropTypes from "prop-types";
import { LinearProgress } from "@mui/material";
import styles from './LoadingBar.module.scss'
import classNames from "classnames";

interface LoadingBarProps {
  variant?: "default" | "primary"
};

const LoadingBar: React.FC<LoadingBarProps> = ({variant = "default"}) => {
  return <LinearProgress className={classNames(styles["mui-progress-bar"], styles[variant])} />;
};

LoadingBar.propTypes = {
  //
};

export default LoadingBar;
